import { gql } from "graphql-tag"

const vendorsMutation = gql`
  type Mutation {
    addCountry(countryAddInput: CountryAddInput!): Country!
    updateCountry(id: ID!, countryUpdateInput: CountryUpdateInput!): Country!
    deleteCountry(id: ID!): DeleteResponse!

    addLabel(labelAddInput: LabelAddInput!): Label!
    updateLabel(id: ID!, labelUpdateInput: LabelUpdateInput!): Label!
    deleteLabel(id: ID!): DeleteResponse!

    addStore(storeAddInput: StoreAddInput!): Store!
    updateStore(id: ID!, storeUpdateInput: StoreUpdateInput!): Store!
    deleteStore(id: ID!): DeleteResponse!

    addStoreLink(storeLinkAddInput: StoreLinkAddInput!): StoreLink!
    updateStoreLink(
      id: ID!
      storeLinkUpdateInput: StoreLinkUpdateInput!
    ): StoreLink!
    deleteStoreLink(id: ID!): DeleteResponse!
    bulkUpdateStoreLinks(input: BulkStoreToggleInput!): BulkStoreTogglePayload!

    addVendor(
      vendorAddInput: VendorAddInput!
      socialLinksAddInput: SocialLinksAddInput
    ): Vendor!
    updateVendor(
      id: ID!
      vendorUpdateInput: VendorUpdateInput!
      socialLinksUpdateInput: SocialLinksUpdateInput
    ): Vendor!
    deleteVendor(id: ID!): DeleteResponse!
  }
`

export default vendorsMutation
